import axios from 'axios';
import { canonBreakers, isCanonBreaker } from './canonBreakers';
import { getFullImageUrl, getThumbnailUrl } from './BreakerImageAPI';

const API_ENDPOINT = 'https://duskbreakers.gg/api/breakers/all_breakers_minified.json';

type ApiBreakerAttribute = {
  trait_type: string;
  value: string;
};

type ApiBreaker = {
  name: string;
  description: string;
  image: string;
  external_url: string;
  attributes: ApiBreakerAttribute[];
};

const transformAttributes = (attributes: ApiBreakerAttribute[], isCanon: boolean) => {
  return [
    {
      traitType: 'Canon',
      value: isCanon ? 'True' : 'False',
    },
    ...attributes.map(({ trait_type, value }) => {
      return {
        value,
        traitType: trait_type,
      };
    }),
  ];
};

const transformBreakers = (breakers: ApiBreaker[]) => {
  return breakers.map(({ name, description, external_url, attributes }) => {
    const id = parseInt(name.split('#')[1], 10);
    const isCanon = isCanonBreaker(id);

    return {
      id,
      name: isCanon ? canonBreakers[id].name : name,
      description,
      isCanon,
      externalUrl: external_url,
      attributes: transformAttributes(attributes, isCanon),
      imageUrls: {
        full: getFullImageUrl(id),
        thumbnail: getThumbnailUrl(id),
      },
    };
  });
};

export const getAllBreakers = async () => {
  const { data } = await axios.get<ApiBreaker[]>(API_ENDPOINT);
  return transformBreakers(data);
};
